import React from 'react'
import ReactDOM from 'react-dom'
import { Editor } from '@tinymce/tinymce-react'

import withStyles from '@material-ui/core/styles/withStyles'

import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import MenuItem from '@material-ui/core/MenuItem'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

import PhotoCameraIcon from '@material-ui/icons/PhotoCamera'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import green from '@material-ui/core/colors/green'
import { rankItems, countryItems, RANK_TYPES } from '../../../constants'
import { getRootURL } from '../../../lib';
import { Word } from '../../../containers';
import { WID } from '../../../constants/Language';

const styles = theme => ({
  card: {
    maxWidth: 680,
    boxShadow: 'none',
    margin: '0 auto',
  },
  cardActions: {
    justifyContent: 'flex-end',
    padding: theme.spacing.unit * 2,
  },
  formGroup: {
    marginBottom: theme.spacing.unit * 4,
  },
  label: {
    marginBottom: theme.spacing.unit * 1,
    color: theme.palette.grey[700],
  },
  rankLabel: {
    width: 150,
    marginRight: theme.spacing.unit * 5,
  },
  textField: {
    width: '100%',
    maxWidth: 250,
  },
  selectField: {
    width: '100%',
    maxWidth: 100,
  },
  selectCountryField: {
    width: '100%',
    maxWidth: 250,
  },
  avatarControlLabelBox: {
    marginBottom: theme.spacing.unit * 2
  },
  photoCameraIcon: {
    marginRight: theme.spacing.unit,
    color: theme.palette.primary.main,
  },
  avatarPhotoBox: {
    width: 100,
    height: 100,
    backgroundColor: theme.palette.grey[200],
    overflow: 'hidden',
    position: 'relative',
  },
  avatarPhoto: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    height: '100%',
  },
  headerControlLabelBox: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  headerPhotoBox: {
    width: 600,
    height: 100,
    backgroundColor: theme.palette.grey[200],
    overflow: 'hidden',
    position: 'relative',
  },
  headerPhoto: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: 'auto',
  },
  successIcon: {
    color: green[600],
    marginRight: theme.spacing.unit,
  },
  success: {
    color: green[600],
  },
  errorIcon: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing.unit,
  },
  error: {
    color: theme.palette.error.dark,
  },
  baselineBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  centerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }
})

const ResultIcon = (props) => {
  const { classes, result } = props
  return (
    <div>
      {result === true  ? (
        <div className={classes.centerBox}>
          <CheckCircleIcon className={classes.successIcon}/>
          <Typography className={classes.success}><Word wid={WID.ACCOUNT_SETTINGS_CARD.SUCCESS}/></Typography>
        </div>
      ) : result === false ? (
        <div className={classes.centerBox}>
          <ErrorIcon className={classes.errorIcon}/>
          <Typography className={classes.error}><Word wid={WID.ACCOUNT_SETTINGS_CARD.FAILED}/></Typography>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  )
}

class AccountSettingsCard extends React.Component {
  componentDidMount() {
    this.props.init()
  }

  componentWillUnmount() {
    this.props.unmount()
  }

  handleClickAvatar = () => {
    var avatarUploadDom = ReactDOM.findDOMNode(this.refs.avatarUpload)
    if (avatarUploadDom) {
      avatarUploadDom.click()
    }
  }

  handleClickHeader = () => {
    var headerUploadDom = ReactDOM.findDOMNode(this.refs.headerUpload)
    if (headerUploadDom) {
      headerUploadDom.click()
    }
  }

  handleChange = (name) => (event) => {
    var reader = new FileReader()
    reader.onload = () => {
      this.props.handleChangePhoto(name, reader.result)
    }
    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0])
    }
  }

  render() {
    const { classes, theme, user, width, settings, avatarPhotoURL, headerPhotoURL, userName, displayName, rank, country, city, birthday, profileHTML, error, disableSendButton, result, isSaving, handleChangeText, handleChangeTinyMCE, handleSave, language } = this.props
    if (settings === undefined) {
      return (<div></div>)
    }
    var values = {
      avatarPhotoURL,
      headerPhotoURL,
      userName,
      displayName,
      country,
      city,
      rank,
      birthday,
      profileHTML,
    }
    var photo =
      avatarPhotoURL ? avatarPhotoURL :
      user.photo ? user.photo : undefined
    var styles = {
      headerPhoto: {
        width: width > 632 ? 600 : width - 32,
        height: width > 632 ? 100 : (width - 32) * 100 / 632
      },      
      profileSize: {
        color: error.profileHTML ? theme.palette.error.main : theme.palette.grey[500],
        margin: `${theme.spacing.unit}px 0`,
      }
    }

    return (
      <Card className={classes.card}>
        <CardHeader title={<Word wid={WID.ACCOUNT_SETTINGS_CARD.TITLE}/>}/>
        <CardContent>
          <div className={classes.avatarControlLabelBox}>
            <div className={classes.centerBox}>
              <Typography className={classes.label}></Typography>
              <ResultIcon result={result.avatarPhotoURL} classes={classes}/>
            </div>
            <div className={classes.avatarPhotoBox} onClick={this.handleClickAvatar}>
              {photo && (<img src={photo} alt={'avatar'} className={classes.avatarPhoto}/>)}
            </div>
            <input
              id='avatarPhotoURL'
              ref='avatarUpload'
              type="file"
              name="avatar"
              accept="image/*"
              onChange={this.handleChange('avatarPhotoURL')}
              style={{display: 'none'}}
            />
            <Button variant='text' onClick={this.handleClickAvatar}>
              <PhotoCameraIcon className={classes.photoCameraIcon}/>
              <Typography color='primary'><Word wid={WID.ACCOUNT_SETTINGS_CARD.CHANGE_BUTTON}/></Typography>
            </Button>
          </div>
          <div className={classes.headerControlLabelBox}>
            <div className={classes.centerBox}>
              <Typography className={classes.label}><Word wid={WID.ACCOUNT_SETTINGS_CARD.HEADER_LABEL}/></Typography>
              <ResultIcon result={result.headerPhotoURL} classes={classes}/>
            </div>
            <div className={classes.headerPhotoBox} onClick={this.handleClickHeader} style={styles.headerPhoto}>
              {headerPhotoURL && (<img src={headerPhotoURL} alt={'header'} className={classes.headerPhoto}/>)}
            </div>
            <input
              id='headerPhotoURL'
              ref='headerUpload'
              type="file"
              name="userfile"
              accept="image/*"
              onChange={this.handleChange('headerPhotoURL')}
              style={{display: 'none'}}
            />
            <Button variant='text' onClick={this.handleClickHeader}>
              <PhotoCameraIcon className={classes.photoCameraIcon}/>
              <Typography color='primary'><Word wid={WID.ACCOUNT_SETTINGS_CARD.CHANGE_BUTTON}/></Typography>
            </Button>
          </div>
          <div className={classes.formGroup}>
            <div className={classes.baselineBox}>
              <TextField
                error={error.hasSameUserName}
                label={<Word wid={WID.ACCOUNT_SETTINGS_CARD.USER_NAME_LABEL}/>}
                value={userName}
                helperText={`${getRootURL()}/user/${userName}`}
                onChange={handleChangeText('userName')}
                className={classes.textField}
                margin='normal'
              />
              <ResultIcon result={result.userName} classes={classes}/>
            </div>
            {error.hasSameUserName && (
              <Typography color='error'><Word wid={WID.ACCOUNT_SETTINGS_CARD.ERROR_MESSAGE_NAME_IS_ALREADY_BEING_USED}/></Typography>
            )}
            <div className={classes.baselineBox}>
              <TextField
                label={<Word wid={WID.ACCOUNT_SETTINGS_CARD.DISPLAY_NAME_LABEL}/>}
                value={displayName ? displayName : ''}
                onChange={handleChangeText('displayName')}
                className={classes.textField}
                margin='normal'
              />
              <ResultIcon result={result.displayName} classes={classes}/>
            </div>
            <div className={classes.baselineBox}>
              <TextField
                value={rank}
                select
                label={<Word wid={WID.ACCOUNT_SETTINGS_CARD.RANK_LABEL}/>}
                onChange={handleChangeText('rank')}
                className={classes.selectField}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
                margin='normal'
              >
                {rankItems.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.type === RANK_TYPES.DAN ? (
                      <Word wid={WID.RANK_ITEMS.DAN} insert={{ number: item.number }}/>
                    ) : item.type === RANK_TYPES.KYU ? (
                      <Word wid={WID.RANK_ITEMS.KYU} insert={{ number: item.number }}/>
                    ) : ('')}
                  </MenuItem>
                ))}
              </TextField>
              <ResultIcon result={result.rank} classes={classes}/>
            </div>
            <div className={classes.baselineBox}>
              <TextField
                value={country}
                select
                label={<Word wid={WID.ACCOUNT_SETTINGS_CARD.COUNTRY_LABEL}/>}
                onChange={handleChangeText('country')}
                className={classes.selectCountryField}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
                margin='normal'
              >
                {countryItems.map((item, index) => (
                  <MenuItem key={index} value={item.value}>{`${item.value} : ${item.label}`}</MenuItem>
                ))}
              </TextField>
              <ResultIcon result={result.country} classes={classes}/>
            </div>
            <div className={classes.baselineBox}>
              <TextField
                label={<Word wid={WID.ACCOUNT_SETTINGS_CARD.CITY_LABEL}/>}
                value={city}
                onChange={handleChangeText('city')}
                className={classes.textField}
                margin='normal'
              />
              <ResultIcon result={result.city} classes={classes}/>
            </div>
            <div className={classes.baselineBox}>
              <TextField
                label={<Word wid={WID.ACCOUNT_SETTINGS_CARD.BIRTHDAY_LABEL}/>}
                type="date"
                value={birthday}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleChangeText('birthday')}
                className={classes.textField}
                margin='normal'
              />
              <ResultIcon result={result.birthday} classes={classes}/>
            </div>
          </div>
          <div className={classes.centerBox}>
            <Typography className={classes.label}><Word wid={WID.ACCOUNT_SETTINGS_CARD.SELF_INTRODUCTION_LABEL}/></Typography>
            <ResultIcon result={result.profileHTML} classes={classes}/>
          </div>
          <Editor
            apiKey="k1muhvxtlcxng632p2jp9t6qxkoyqo4lacipy79fjn06aa67"
            init={{
              plugins: 'link table',
            }}
            value={profileHTML}
            onEditorChange={handleChangeTinyMCE}
          />
          <Typography style={styles.profileSize}>Size: {profileHTML.length} / 2000</Typography>
        </CardContent>
          <CardActions className={classes.cardActions}>
            {isSaving ? (
              <CircularProgress size={30}/>
            ) : (
              <Button disabled={disableSendButton} variant='contained' color='primary' onClick={handleSave(values, language)}>
                <Word wid={WID.ACCOUNT_SETTINGS_CARD.SAVE_BUTTON}/>
              </Button>
            )}
          </CardActions>
      </Card>
    )
  }
}

export default withStyles(styles, { withTheme: true })(AccountSettingsCard)




// WEBPACK FOOTER //
// ./src/Pages/Settings/components/AccountSettingsCard.js